import React, { useState,useEffect } from 'react'
import {MDBRow, MDBCol, MDBInput, MDBBtn , toast,MDBModal,MDBModalBody,MDBModalHeader,MDBIcon} from 'mdbreact';
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from 'axios';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from '../components/WarningBox';
import InfoBox from '../components/InfoBox';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { set } from 'date-fns';




const AddEditDealerPrices=(props)=>{

    const useMountEffect = (functionName) => useEffect(functionName, [])
       const serverURL=props.apiServer 
 ;

 const bearer={
  headers: {
     Authorization: "Bearer " + sessionStorage.getItem("hash")
  }
}


  const [frm, setValues] = useState({
    code:props.code
    ,dealercode:props.dealercode
    ,bundlecode:{value: '', label:''}
   
    ,price:0
   
    ,usercode:sessionStorage.getItem("msal.uc")
 
  });
  
  

  const [unitofmeasure,setUnitOfMeasure]=useState('');
  const [disabled,setDisabled]=useState('');
     
  const updateField = e => {
       
        const target=e.target;
       
        let  value =target.value;
        let name=target.id;
      
        if(target.type==="checkbox")
        {
          value=target.checked;
          setValues({ ...frm, [name]: value });
        }
        else
        {
          setValues({ ...frm, [name]: value });
        }
  
       

  };
  

  
  const  handleChange = objName => (selOption) => {
  
    setValues({ ...frm, [objName]: selOption });


 };
  

    
  const getDateValue = dtPickerName =>(actualValue)=>{

        setValues({ ...frm, [dtPickerName]:actualValue});
  
  } 

  
   
      
   
  function submitHandler (event){
        event.preventDefault();
        event.target.className += " was-validated";
        
        
        savedealerprices();
       
        
  };
    

  const [errorMessage,setErrorMessage]=useState("");

  const [modalWarning,showWarningBox]=useState(false);
  
  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  
    }


  const [modalInfo,showInfoBox]=useState(false);
  
 

  const toggleInfoBox = () => {
    showInfoBox(!modalInfo);
  
}

  

  const [bundleoptionsnew, setbundleoptionsnew] = useState([]);
  const loadBundles=()=>
  {
    
    Axios.get(serverURL + '/getbundleoptionsnew',bearer)
        .then(res => {
         
          setbundleoptionsnew(res.data);
           
          
        })
  
        .catch(error => {
          setErrorMessage(error);
            toggleWarningBox();
        
        }
    );  
  }


  

  const ClearFields=()=>{
    setValues({ ...frm,
        code:props.code
        ,dealercode:props.dealercode
        ,bundlecode:{value: '', label:''}
       
        ,price:0
       
        ,usercode:sessionStorage.getItem("msal.uc")
      
      });   


  }

 
  const loaddealerprice=()=>
  {
   

    if(props.code==="new")
    {
       setDisabled('');
        ClearFields();
        return;
    }
    setDisabled('disabled');
    Axios.get(serverURL + '/loaddealerprice?code=' + props.code ,bearer)
      .then(res => 
      {
        if(res.data!=="empty")
        {
          setDisabled('disabled');
            setValues({ ...frm,


                code:props.code
                ,dealercode:props.dealercode
                ,bundlecode:{value: res.data.bundlecode, label:res.data.bundle}
               
                ,price:res.data.price
               
                ,usercode:sessionStorage.getItem("msal.uc")

            
               
              
            });   
                  
                  
        }
        else
        {
       
           ClearFields();
        }
           
    
      })
      
      .catch(error => {
        setErrorMessage(error);
        toggleWarningBox();
          
      });  
    
         
  }


  const savedealerprices=()=> {
    

     const data =frm;
 

    Axios.post(props.apiServer + "/savedealerprices", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
 
            setValues({...frm, code : res.data.code});
            
           
            // notify(res.data.message);
            //  toast.info(res.data.message, {
            //     closeButton: false
                
            //   });
            //  props.showResult(res.data.message);
              props.refreshGrid(res.data.message);
       
       }
       else {
       
        toast.warning(res.data.message, {
            closeButton: false
            
          });
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
         console.log(res.data.message);
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     }); 
   
 }



 const [isAdmin,checkAdmin]=useState(0);


         
 function checkAdminAccess() {
     
 
   Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc"),bearer)
    .then(res => {
    
       checkAdmin(0);
       checkAdmin(res.data[0].isadmin);
       setPreloader("none");
    })
  
    .catch(error => {
     
     console.log(error);
    });  
   
  
  
  
  }

  const [modalDelete,showDeleteBox]=useState(false);

  const deleteRecord=()=>{
    if(props.code==="new")
    {
      setErrorMessage("Please select a record!")
      toggleWarningBox();
      
      return;
    }
      
    showDeleteBox(!modalDelete);
  
  }
  
  function confirmDelete(){
   
  
    removeDealerPrice();
  
    showDeleteBox(!modalDelete);
    
    
    
  }

  const removeDealerPrice=()=>
 {
    const data =frm;

   
     Axios.post(props.apiServer + "/removedealerprices", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
       
        props.refreshGrid(res.data.message);
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
        //  toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
        //  toggleWarningBox();
     });

  
   
    //  props.refreshGrid(res.data.message);
 }


 useMountEffect(loadBundles);
 

 useMountEffect(checkAdminAccess);
/* eslint-disable */


useEffect(() => {
    loaddealerprice();
   
}, [props.code]);


// useMountEffect(loadSeedPlanting);






    return (
        <React.Fragment>
       
          
                <MDBRow>
                <MDBCol md="12">
              
                    <form
                    className="needs-validation"
                    onSubmit={submitHandler}
                    noValidate
                    >
                     

                 
                

                
                   <MDBRow  hidden>
                        <MDBInput  
                      
                            value={frm.code} 
                            id="code"  
                            label="Code" 
                            >
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                      
                   </MDBRow>
                   <MDBRow  hidden>
                        <MDBInput  
                      
                            value={frm.dealercode} 
                            id="dealercode"  
                            label="dealercode" 
                            >
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                      
                   </MDBRow>

            
                    <MDBRow>
                        <MDBCol md="12">
                        <label className="grey-text"><small>&nbsp;Bundle</small></label>
                      
                        </MDBCol>
                    </MDBRow>

                    <MDBRow>
                        <MDBCol md="12">
                     
                         <Select
                            placeholderText="Select bundle"
                            isSearchable
                            value={frm.bundlecode}
                            onChange={handleChange("bundlecode")}
                            options={bundleoptionsnew}
                            required
                            className={disabled}/>
 
                            <div className="invalid-feedback ">
                                 This field is required!
                            </div>
                                 <div className="valid-feedback"></div>
                        
                        <br/>
                        </MDBCol>
                    </MDBRow>

                
                    <MDBRow>
                        <MDBCol md="12" className="text-left">
                        <MDBInput  
                                
                                value={frm.price} 
                                id="price"  
                                label="Price" 
                                type="textarea"
                                onChange={updateField}
                              
                                
                                >
                                    <div className="invalid-feedback">
                                    This field is required!
                                </div>
                                <div className="valid-feedback"></div>

                            </MDBInput>
                        </MDBCol>

                       

                   </MDBRow>
       

                 



                  

                  
                    <MDBBtn className="blue lighten-1" type="submit" >
                        Save
                    </MDBBtn>
                    {props.code==="new" ? ( <MDBBtn className="cloudy-knoxville-gradient blue-text" onClick={props.toggleModal} >
                        Close
                    </MDBBtn>):("")}

                    {
                         isAdmin==1 && props.code!=="new" ? (<MDBBtn color="danger" onClick={deleteRecord} >
                          Delete
                      </MDBBtn> ):("")
                          
                       
                       
                    }
                   
                    </form>
                    
                </MDBCol>
            </MDBRow>


              
            <MDBModal
              
              backdrop={false}
              isOpen={modalDelete}
              toggle={deleteRecord}
          >
              <MDBModalHeader
              className="text-left black-text cloudy-knoxville-gradient"
              titleClass="w-100"
              tag="h5"
            
              >
              
                 
                    
              </MDBModalHeader>
              <MDBModalBody className="text-center">
              
              <MDBRow>
                        <MDBCol
                        size="3"
                        className="text-center"
                        >
                         <MDBIcon icon="trash-alt" size="5x" className="red-text" />  
                       
                        </MDBCol>
                        <MDBCol size="9" className="black-text text-center">
                        <p> 
                        
                        </p>
                        <p>
                           
                           Do you really want to delete this record?
                          
                        </p>
                        <p className="text-center">
                        <MDBBtn color="danger"  onClick={confirmDelete}>
                            Yes
                        </MDBBtn>
                        <MDBBtn className="cloudy-knoxville-gradient blue-text"  onClick={deleteRecord}>
                            Cancel
                        </MDBBtn>
                               
                        </p>
                        </MDBCol>
                  </MDBRow>
                  
              </MDBModalBody>
          </MDBModal>


            <InfoBox errorMessage={errorMessage} isOpen={modalInfo} toggleModal={toggleInfoBox} />
            <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>
            {/* <MessagePersonalInfo /> */}
        </React.Fragment>
    );

}
export default AddEditDealerPrices;
